import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Redireciona para home quando não há quote na URL e a lista de quotes está vazia.
 * quoteLoading e quotes vêm do useQuoteData (evita duplicar leitura da store).
 */
export function usePersonalCoverageRedirect(quoteLoading: boolean, quotes: unknown[]) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const quoteHash = searchParams.get('quote');
  const planParam = searchParams.get('plan');
  const distribuitorParam = searchParams.get('dis');
  const orgParam = searchParams.get('org');
  const sellerParam = searchParams.get('seller');

  useEffect(() => {
    if (quoteLoading || quotes.length > 0 || quoteHash) return;

    const queryTail = `${distribuitorParam ? `&dis=${distribuitorParam}` : ''}${orgParam ? `&org=${orgParam}` : ''}${
      sellerParam ? `&seller=${sellerParam}` : ''
    }`;
    navigate(`/?modal=true&plan=${planParam}${queryTail}`);
  }, [quoteLoading, quotes.length, quoteHash, planParam, distribuitorParam, orgParam, sellerParam, navigate]);
}
